module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1000"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "pb-2"
  }, [_c('v-card-title', {
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Engagements rate for @" + _vm._s(_vm.handle))])]), _vm._v(" "), _c('v-card-subtitle', [_c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("Distrubution by engagement rate for influencers having followers between " + _vm._s(_vm._f("abbr")((_vm.followersRange.left_number || 0))) + " and " + _vm._s(_vm._f("abbr")((_vm.followersRange.right_number || 0))))])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": "50",
      "hide-default-footer": true,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "item.rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', {
          class: {
            'font-weight-bold': item.handle
          }
        }, [_vm._v(_vm._s(item.rate))]), _vm._v(" "), (item.handle) ? _c('span', {
          staticClass: "font-weight-bold ml-5"
        }, [_vm._v("@" + _vm._s(item.handle))]) : _vm._e(), _vm._v(" "), (item.median) ? _c('span', {
          staticClass: "caption ml-5"
        }, [_vm._v("Median")]) : _vm._e()])])]
      }
    }, {
      key: "item.total",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                  " + _vm._s(_vm._f("thousandSeprator")(item.total)) + "\n                ")])])]
      }
    }], null, true)
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67cf3cc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/MedianEngagementsModal.vue
// module id = 2167
// module chunks = 0